/**
 * Service worker registration for Inconti PWA.
 * Only registers in production-like environments (where SW is served).
 */
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  // Wait until window load to avoid blocking initial render.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Auto-update: detect new SW and prompt reload silently
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              // New version ready
              console.info("[SW] Nueva versión disponible — recarga para aplicar.");
            }
          });
        });
      })
      .catch((err) => console.warn("[SW] registro falló:", err));
  });
}
